import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

// проверяем помещается ли контент в контейнер
const useContentOverflow = (refEl) => {
  const [isOverflow, setIsOverflow] = useState(false);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const node = refEl.current;

    if (node) {
      const updateState = () => {
        const { clientWidth, scrollWidth } = node;
        if (scrollWidth > clientWidth) {
          setIsOverflow(true);
        } else {
          setIsOverflow(false);
        }
      };

      const handleResize = throttle(updateState, 500);

      updateState();

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
        handleResize.cancel();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isOverflow;
};

export default useContentOverflow;
